{
  "Accessibility menu": "অভিগম্যতা মেনু",
  "Close": "বন্ধ করুন",
  "Content adjustments": "কন্টেন্ট সংশোধন",
  "Navigation adjustments": "নেভিগেশন সংশোধন",
  "Align Left": "বাম দিকে সারিবদ্ধ করুন",
  "Adjust Font Size": "ফন্ট সাইজ সংশোধন",
  "Highlight Title": "শিরোনাম উজ্জ্বল করুন",
  "Highlight Links": "লিঙ্কগুলি উজ্জ্বল করুন",
  "Readable Font": "পঠনীয় ফন্ট",
  "Colour adjustments": "রঙ সংশোধন",
  "Dark Contrast": "অন্ধকারী প্রতিবিম্ব",
  "Light Contrast": "আলোকিত প্রতিবিম্ব",
  "High Contrast": "উচ্চ প্রতিবিম্ব",
  "High Saturation": "উচ্চ সত্রাজন",
  "Low Saturation": "নিম্ন সত্রাজন",
  "Monochrome": "একরঙ",
  "Tools": "সরঞ্জাম",
  "Reading Guide": "পড়ার গাইড",
  "Big Cursor": "বড় কার্সর",
  "Increase Font Size": "ফন্ট সাইজ বাড়ান",
  "Decrease Font Size": "ফন্ট সাইজ কমান",
  "Letter Spacing": "অক্ষর বিরাটি",
  "Line Height": "লাইন উচ্চতা",
  "Font Weight": "ফন্ট ওজন",
  "Dyslexia Font": "ডাইসলেক্সিয়া ফন্ট",
  "Language": "ভাষা",
  "Accessibility widget": "অভিগম্যতা মেনু খোলুন",
  "Accessibility Profiles": "অভিগম্যতা প্রোফাইল",
  "Cognitive Disability": "জ্ঞানীয় অক্ষমতা",
  "Seizure Safe": "মৃগীরোগীদের জন্য নিরাপদ",
  "Accessibility statement": "অভিগম্যতা বিবৃতি",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "অ্যানিমেশন বন্ধ করুন",
  "Reset all settings": "নির্ধারণ পুনরায় সেট করুন",
  "Shortcut:": "Shortcut:"
}
